/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import Intro, {IntroFooter} from 'dnb-design-system-portal/src/shared/tags/Intro';
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    a: "a",
    h2: "h2",
    pre: "pre",
    code: "code",
    hr: "hr"
  }, _provideComponents(), props.components);
  return _jsxs(Intro, {
    children: [_jsx(_components.h1, {
      children: "Icons"
    }), _jsxs(_components.p, {
      children: ["Icons are categories on two ", _jsx(_components.a, {
        href: "!/icons",
        children: "main groups"
      }), " and comes in two sizes each:"]
    }), _jsx(_components.h2, {
      children: _jsx(_components.a, {
        href: "!/icons/primary",
        children: "Primary Icons"
      })
    }), _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        children: "<Button icon=\"chevron_right\" text=\"Button\" />\n"
      })
    }), _jsx(_components.h2, {
      children: _jsx(_components.a, {
        href: "!/icons/secondary",
        children: "Secondary Icons"
      })
    }), _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        children: "import { hamburger } from `@dnb/eufemia/icons`\n<Button icon={hamburger} text=\"Button\" />\n"
      })
    }), _jsxs(_components.p, {
      children: ["Primary Icons are used inside of other custom ", _jsx(_components.a, {
        href: "!/uilib/components",
        children: "Components"
      }), " and are imported by default."]
    }), _jsxs(_components.p, {
      children: ["It is recommended to use the ", _jsx(_components.a, {
        href: "!/uilib/components/icon",
        children: "Icon Component"
      }), " to display icons for best accessibility."]
    }), _jsx(_components.hr, {}), _jsx(IntroFooter, {
      href: "/uilib/intro/10-layout",
      text: "Next - Layout"
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
